import { useGetTagsQuery, TagState } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { tagsColumns, type TagRow, type TagFilterInput } from '../constants/tagsColumns';

const defaultFilters: Partial<TagFilterInput> = {
    state: [TagState.Regular],
};

export const TagsList = () => {
    const { loading: tagsLoading, data: tagsData, error: tagsError } = useGetTagsQuery();

    if (tagsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!tagsData || tagsError) {
        throw new Error('Une erreur est survenue lors de la récupération des tags');
    }

    const { tags } = tagsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<TagRow, TagFilterInput>
                columns={tagsColumns}
                data={tags}
                defaultFilters={defaultFilters}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/tag/${row._id}`}
                searchPlaceholder="Nom du tag"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
